import React from 'react';
import classnames from 'classnames';
import * as _ from 'lodash';
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import styles from './styles.module.scss';

const Section8Text4 = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {
    identifyMethodType,
    rightsRegistryDesc,
    rightsRegistryDate,
    floor,
    registeredArea,
    sharedParts,
    attachedText,
    rightsRegistryRegulations,
    warningNote,
    warningNoteText,
    rightsRegistryMortgage
  } = context.data.pdfData;

  const showText = _.some([
    rightsRegistryDesc,
    rightsRegistryDate,
    floor,
    registeredArea,
    sharedParts,
    attachedText,
    rightsRegistryRegulations,
    warningNote,
    warningNoteText,
    rightsRegistryMortgage
  ]);

  return (
    <div ref={ref}>
      {showText && identifyMethodType === 1 && (
        <div className={classnames(styles.itemText, styles.innerPadding)}>
          <span className={classnames(styles.bold, styles.underline)}>בנכסים הרשומים בפנקס הבתים המשותפים: </span>
        </div>
      )}
    </div>
  );
});

export default Section8Text4;
